import { OperateChecker } from 'apps/components';
import { Button, EmptyText, EmptyWrapper } from 'components';
import { routerStore } from 'core';
import { ProjectEmptyIcon } from 'icons';
import { observer } from 'mobx-react';
import React from 'react';
import { themes } from 'styles/themes/wikifactoryNew';
import { ComponentBaseProps } from 'types';

export type EmptyProjectWithCreateProps = {
  emptyText?: string;
  hideButton?: boolean;
} & ComponentBaseProps;

export const EmptyProjectWithCreate = observer(
  ({
    emptyText = 'No Projects yet.',
    hideButton = false,
    className = '',
    style,
  }: EmptyProjectWithCreateProps) => {
    const { route } = routerStore;

    return (
      <EmptyWrapper
        className={`border border-gray-200 py-8 ${className}`}
        style={style}
      >
        <ProjectEmptyIcon />
        <EmptyText text={emptyText} />
        {!hideButton && (
          <OperateChecker type='canCreateIn'>
            <>
              <Button
                outline
                size='small'
                style={{
                  fontSize: 16,
                  borderColor: themes.color.wfBlack,
                }}
                iconPosition='right'
                icon='add'
                text='New Project'
                variant='tertiary'
                onClick={() =>
                  routerStore.navigate('home.newProject', route.params)
                }
                dataTestId='ProjectPage-newProject-button'
              />
              {/* <p className='mt-4 cursor-pointer text-sm text-black'>
              Learn more about How to create a new Project
            </p> */}
            </>
          </OperateChecker>
        )}
      </EmptyWrapper>
    );
  },
);
